import React from 'react'
import { colors } from '../../../../styles/vars/colors.style'

const ExpeditionRoute1 = ({
  width = 138,
  height = 159,
  stroke = colors.dark,
  mask = colors.light,
  opacity = 1,
  pathLength = 294,
  responsive = true,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 138 159"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <path
        opacity={opacity}
        stroke={stroke}
        strokeWidth={1}
        strokeDasharray="2 3"
        d="M52.5008,6.00098C69.0008,67.2035 35.1318,106.517 16.8517,106.517C-1.42829,106.517 -8.87571,113.963 16.8517,115.317C42.5792,116.671 129.24,127.502 145.489,158.642"
      />
      <path
        opacity={opacity}
        stroke={mask}
        strokeWidth={2}
        ref={forwardRef.line}
        strokeDashoffset={0}
        strokeDasharray={pathLength}
        d="M52.5008,6.00098C69.0008,67.2035 35.1318,106.517 16.8517,106.517C-1.42829,106.517 -8.87571,113.963 16.8517,115.317C42.5792,116.671 129.24,127.502 145.489,158.642"
      />

      <path
        opacity={0}
        ref={forwardRef.arrow}
        d="M50.9725 1.70033C51.0274 1.476 51.3045 1.39514 51.4713 1.5548L56.0602 5.94525C56.227 6.1049 56.1585 6.38532 55.9368 6.45001L49.8401 8.22881C49.6184 8.2935 49.4099 8.09393 49.4647 7.86959L50.9725 1.70033Z"
        fill={stroke}
      />
    </svg>
  )
}

export default ExpeditionRoute1
